import type { Dimension } from '@/types'

/** Maps UI dimension to API `DimensionTypeSchema` string. */
export function toApiDimensionType(d: Dimension): string {
  switch (d) {
    case 'device_type':
      return 'device_type'
    case 'cdn_edge':
      return 'cdn_edge'
    case 'game':
      return 'game'
    case 'studio':
      return 'studio'
    case 'user':
      // Per-stream listing uses `POST /api/stream`, not dimension aggregates.
      return 'continent'
    default:
      return d
  }
}
